/*
 * @Author: Vanny
 * @Date: 2020-05-16 17:53:20
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-02 18:09:17
 * @Description:
 */
import axios from 'axios';
import qs from 'querystring';
import { inverseCamel } from 'src/tools';

/**
 * 导出历史列表
 *
 * task_type
 * template_goods_horizontal - 商品横排
 * template_goods_vertical - 商品竖排
 * template_doc_info - 订单详情
 * template_mc_doc_list - 销售单列表
 * template_mc_doc_detail - 销售单明细
 * template_client - 客户
 * template_supplier - 供货商
 * template_customer - 客户和供应商
 * template_payment - 财务
 * template_purchase_doc - 进货单
 * template_inventory_doc - 盘点单
 * template_transfer_doc - 调货单
 */
export function requestImportList(params) {
  return axios.get(`/report/get_task_list?${qs.stringify(params)}`);
}
// 导出Excel
export function requestImportTask(params) {
  return axios.get(`/report/get_task_url?${qs.stringify(params)}`);
}
// 获取导入模板
export function requestUploadTemplate(params) {
  return axios.get('/report/get_import_template', { params, type: 'download' });
}
// 获取导入规则
export function requestUploadRule(params) {
  return axios.get('/report/get_import_rule', { params });
}
// 获取导入接口
export function requestUploadFile(params) {
  return axios.post(
    '/report/import_data',
    Object.keys(params).reduce((acc, k) => {
      acc[inverseCamel(k)] = params[k];
      return acc;
    }, {})
  );
}
// mc报表列表接口
export function requestReportList() {
  return axios.get(`/report/report_list`);
}
// 导出报表接口
export function requestReportExport(params) {
  return axios.get('/report/report_export', { responseType: 'blob', params});
}
